<template>
<div style="width:100vw">
    <div class="container" style="position: relative;bottom: -13px;">
        <div class="row" >
        <div
          class="col-2 content"
          slot="content"
          style="z-index: 999999;  background-color: #149240;    margin-top: 16px;"
        >
          <a style="
          position: absolute;
          left: 25px;
          top: 50%;
          transform: translateY(-50%);
          padding: 0;" href="javascript:void(0)" @click="showDrawer">
            <i
              class="fa fa-2x fa-bars icon menuicon-header-style m-0"
              style="color: #000000; background-color: #ffffff !important;"
              aria-hidden="true"
              v-show="showmenuicon"
            ></i>
          <svg v-show="showmenuicon" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 34 34" fill="none" class="alert-icon-red-circle">
          <circle cx="17" cy="17" r="17" fill="#FF0040"></circle>
          </svg>
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 2540 3175"
              style="enable-background:new 0 0 2540 3175;  margin-top:30px;"
              xml:space="preserve"
              height="30"
              width="30"
              v-show="!showmenuicon"
            >
              <g>
                <path
                  d="M1878,2270c39,39,39,104,0,143c-40,40-104,40-144,0L662,1342c-39-40-39-104,0-144L1734,127c40-40,104-40,144,0
                      c39,39,39,104,0,143L878,1270L1878,2270z"
                />
              </g>
            </svg>
          </a>

            </div>
            <div class="col-10 text-left">
                <span class="ml-2"
                 style="
                    font-weight: 700;
                    font-size: 18px;
                 "
                >My Gift Cards</span>
            </div>

        </div>

    </div>
    <div class="gift-card-header">
        <div class="container super-display-header-link">
            <div class="col-4 canpay-crew-padding-left-none canpay-crew-padding-right-none display-header-link" v-on:click="changeTab('all')">
                <div :class="getTabClass('all')"><span class="show-link">All</span></div>
            </div>
            <div class="col-4 canpay-crew-padding-left-none canpay-crew-padding-right-none display-header-link" v-on:click="changeTab('pending')">
                <div :class="getTabClass('pending')"><span class="show-link">Pending</span></div>
            </div>
            <div class="col-4 canpay-crew-padding-left-none canpay-crew-padding-right-none display-header-link" v-on:click="changeTab('redeemed')">
                <div :class="getTabClass('redeemed')"><span class="show-link">Redeemed</span></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "GiftCardsHeader",
  props: {
    currentTab: {
      type: String,
      default: 'all'
    }
  },
  mounted() {
    let self = this;
    self.$root.$on("Menu Drawer Close", function(data) {
      self.showmenuicon = true;
    });

    self.$root.$on("Menu Drawer Open", function(data) {
      setTimeout(function() {
        self.showmenuicon = false;
      }, 30);
    });
  },
  data() {
    return {
      tabs: [
        { title: 'All', value: 'all' },
        { title: 'Pending', value: 'pending' },
        { title: 'Redeemed', value: 'redeemed' }
      ],
      showmenuicon: true,
    }
  },
  methods: {
    goBack() {
      this.$router.push("/giftcard-purchase");
    },
    changeTab(tab) {
      this.$emit('tab-changed', tab);
      this.$root.$emit('gift-cards-tab-changed', tab);
    },
    getTabClass(tabValue) {
      if(this.currentTab === tabValue){
        return 'selected-gift-card-tab'
      }else{
        return 'not-selected-gift-card-tab'
      }
    },
    showDrawer() {
      this.showmenuicon = false;
      this.$root.$emit("Menu Drawer", [""]);
    }
  }
};
</script>
<style scoped>
.super-display-header-link{
    width: 100%;
    display: flex;
    padding:0px!important;
    justify-content: space-between;
}
.display-header-link{
  display:flex;
  justify-content:center
}
.show-link{
position:relative;
top:-9px;
}
.header-link-card{
    position: absolute;
    bottom: 6px;
    width: 100%;
    padding: 0!important;
    margin: 0!important;
}
.selected-gift-card-tab{
  color:#000000!important;
  font-size:12px;
  font-weight:700;
  border-bottom: 5px solid black;
  width: 85%;
}
.not-selected-gift-card-tab{
  color:#787878;
  font-weight:700;
  font-size:12px;
  border:none;
}
.gift-card-header{
position: relative;
bottom: -40px;
background-color:#ffffff;
border-radius:0px 0px 15px 15px;
z-index:8;width:100%;
}
@media only screen and (min-width: 700px) and (max-width:990px){
.gift-card-header{
position: relative;
bottom: -41px;
background-color:#ffffff;
border-radius:0px 0px 15px 15px;
z-index:8;width:100%;
}
}
@media only screen and (min-width: 350px) and (max-width:700px){
  .gift-card-header{
  position: relative;
  bottom: -36px;
  background-color:#ffffff;
  border-radius:0px 0px 15px 15px;
  z-index:8;width:100%;
  }
}
@media only screen and (max-width:320px){
  .gift-card-header {
    position: relative;
    bottom: -28px;
    background-color: #ffffff;
    border-radius: 0px 0px 15px 15px;
    z-index: 8;
    width: 100%;
}
}
</style>